<div class="row align-items-center search-instrument-driver-container">
  <!-- Right side: Text content-->
  <div class="col search-instrument-driver-right-col offset-md-2">
    <!-- Title -->
    <div class="search-instrument-driver-title">
      <a
        [appResultClickTracking]="searchResultEntry"
        class="search-instrument-driver-title-url"
        href="{{ searchResultEntry.uri }}"
      >
        <span [innerHTML]="searchResultEntry.title"></span>
      </a>
    </div>
    <!-- Teaser -->
    <p [innerHTML]="searchResultEntry.teaser" class="search-instrument-driver-teaser"></p>
    <!-- Dispaly URL -->
    <div class="search-instrument-driver-display-url-div">
      <a
        [appResultClickTracking]="searchResultEntry"
        class="search-instrument-driver-display-url"
        href="{{ searchResultEntry.uri }}"
      >
        {{ searchResultEntry.uri }}
      </a>
    </div>
    <!-- Extra Fields-->
    <div *ngIf="searchResultEntry.extraFields" class="search-instrument-driver-extra-fields">
      <div *ngFor="let item of searchResultEntry.extraFields | keyvalue">
        <span class="search-instrument-driver-extra-field">
          <span class="search-instrument-driver-extra-field-key">{{ item.key }}:</span>
          {{ item.value }}</span
        >
      </div>
    </div>

    <div (click)="toggleTable()" class="search-instrument-driver-table-button-div">
      <span class="search-instrument-driver-table-button">{{ searchResultEntry.driversString }}</span>
      <div class="search-instrument-driver-arrow-down d-inline-block" id="search-instrument-driver-arrow-down">
        <svg-icon [key]="driversTableOpened ? 'arrow-up' : 'arrow-down'" height="24px" width="24px"></svg-icon>
      </div>
    </div>
    <span
      *ngIf="dataCompletionResponse?.error || hasError"
      class="search-instrument-driver-mashup-drivers-error-list-mode"
      >{{ 'noDriversFoundErrorMessage' | translate }}</span
    >
    <div
      *ngIf="driversTableOpened && !dataCompletionResponse?.error && !hasError"
      class="search-instrument-driver-table-div"
    >
      <table class="search-instrument-driver-table">
        <thead>
          <tr>
            <th scope="col">{{ 'ade' | translate }}</th>
            <th scope="col">{{ 'driverType' | translate }}</th>
            <th scope="col">{{ 'interfaces' | translate }}</th>
            <th class="d-none d-sm-table-cell" scope="col">{{ 'niCertified' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let result of dataCompletionResponse?.result">
            <tr>
              <td>
                <a
                  [appResultClickTracking]="searchResultEntry"
                  [innerText]="result.ade"
                  href="{{ result.uri }}"
                  target="_blank"
                ></a>
              </td>
              <td [innerText]="result.driverType"></td>
              <td [innerText]="result.interfaces"></td>
              <td [innerText]="result.niCertified" class="d-none d-sm-table-cell"></td>
            </tr>
            <tr class="d-table-row d-sm-none">
              <td class="search-instrument-driver-table-certified-mobile" colspan="3">
                <span class="search-instrument-driver-table-certified-mobile-text">
                  {{ 'niCertifiedCamelCase' | translate }}
                </span>
                <div class="search-instrument-driver-table-certified-mobile-svg-div">
                  <svg-icon [key]="result.niCertified ? 'check' : 'times'"></svg-icon>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
